import { useContext } from "react";
//#region types
import { GrossSalaryChangeContextState } from "models/propTypes/wintSalaryPropTypes";
//#endregion
//#region components
import { GrossSalaryChangeContext } from "./index";
//#endregion

export const useGrossSalaryChangeContext = (): GrossSalaryChangeContextState => {
  const context = useContext(GrossSalaryChangeContext);
  if (!context) {
    throw new Error("useGrossSalaryChangeContext must be used within a GrossSalaryChangeProvider");
  }
  return context;
};
